import React from 'react';

export const Vignette: React.FC = () => <div className="hero__vignette" aria-hidden />;
